/**
 * Center Stone Shape picker: finds the products of this ring's product group (through the
 * cb-shape-lookup section, rendered for a store search of the group name), marks which shapes exist
 * and opens the matching product on click.
 * One product per shape: 2 products = the one with the bigger center stone weight, 3 = the middle one.
 */
(function () {
  'use strict';

  function norm(s) {
    var t = String(s || '').toLowerCase().replace(/\s+cut\b/g, '').trim();
    return /^e\.?\s?cushion$/.test(t) ? 'elongated cushion' : t;
  }
  function weight(w) { var n = parseFloat(String(w || '').replace(',', '.')); return isNaN(n) ? 0 : n; }

  function pick(list) {
    list.sort(function (a, b) { return weight(a.w) - weight(b.w) || String(a.h).localeCompare(String(b.h)); });
    return list[Math.floor(list.length / 2)];
  }

  function load(group) {
    var key = 'cb-shapes:' + group.toLowerCase();
    try { var cached = sessionStorage.getItem(key); if (cached) return Promise.resolve(JSON.parse(cached)); } catch (e) {}
    var url = '/search?q=' + encodeURIComponent(group) + '&type=product&section_id=cb-shape-lookup';
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = /<script[^>]*id="cb-shape-data"[^>]*>([\s\S]*?)<\/script>/.exec(html);
        var data = m ? JSON.parse(m[1]) : [];
        try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) {}
        return data;
      })
      .catch(function () { return []; });
  }

  // The header menu's "Shop by shape" column (what the shopper sees in the mega menu).
  function menuShapes() {
    var heads = document.querySelectorAll('.cbm-col__heading, .cbm-col__title, .cbm-m-col__title');
    for (var i = 0; i < heads.length; i++) {
      if (!/shape/i.test(heads[i].textContent)) continue;
      var list = heads[i].parentElement && heads[i].parentElement.querySelectorAll('li a');
      if (!list || !list.length) continue;
      return Array.prototype.map.call(list, function (a) {
        var icon = a.querySelector('.cbm-icon');
        var name = (a.querySelector('span:not(.cbm-icon)') || a).textContent.trim();
        return { title: name, icon: icon ? icon.outerHTML : '' };
      }).filter(function (s) { return s.title; });
    }
    return [];
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function rebuild(root) {
    var shapes = menuShapes();
    if (!shapes.length) return;
    var grid = root.querySelector('.sp__grid');
    var current = root.dataset.shape;
    grid.innerHTML = shapes.map(function (s) {
      var n = norm(s.title);
      var on = n === current;
      return '<button type="button" class="sp__item is-pending' + (on ? ' is-on' : '') + '" data-sp-shape="' + esc(n) + '" data-sp-title="' + esc(s.title) + '" aria-pressed="' + on + '">' +
        s.icon + '<span class="sp__name">' + esc(s.title) + '</span></button>';
    }).join('');
  }

  // The metal the shopper picked on this page (metal option block, else a gold / platinum variant option).
  function chosenMetal() {
    var mo = document.querySelector('[data-mo-input]');
    if (mo && mo.value) return mo.value;
    var radios = document.querySelectorAll('variant-picker input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) if (/gold|platinum|silver/i.test(radios[i].value)) return radios[i].value;
    return '';
  }

  // Open the other shape's product with the same metal selected (and the same ring size, when one was chosen).
  function go(url, root) {
    var metal = chosenMetal();
    var size = document.querySelector('.rsp [data-rsp-property]');
    try { if (size && size.value) sessionStorage.setItem('cb-carry-size', JSON.stringify({ v: size.value, t: Date.now() })); } catch (e) {}
    root.classList.add('is-loading');
    var plain = function () { location.href = url; };
    if (!metal) return plain();
    fetch(url.split('?')[0] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var m = metal.toLowerCase().replace(/\s+/g, ' ').trim();
        var v = p && p.variants.filter(function (x) {
          return x.options.some(function (o) { return String(o).toLowerCase().replace(/\s+/g, ' ').trim() === m; });
        })[0];
        location.href = v ? url.split('?')[0] + '?variant=' + v.id : url;
      })
      .catch(plain);
  }

  function init(root) {
    if (root.dataset.useMenu === 'true') rebuild(root);
    var group = root.dataset.group;
    var current = root.dataset.shape;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sp-shape]'));
    var target = {};

    load(group).then(function (data) {
      var byShape = {};
      data.forEach(function (p) {
        if (!p || String(p.g || '').trim().toLowerCase() !== group.trim().toLowerCase()) return;
        var s = norm(p.s);
        if (s) (byShape[s] = byShape[s] || []).push(p);
      });
      items.forEach(function (btn) {
        var s = btn.dataset.spShape;
        btn.classList.remove('is-pending');
        var list = byShape[s];
        if (s === current) return; // this page
        if (list && list.length) { target[s] = pick(list).u; }
        else { btn.classList.add('is-off'); btn.setAttribute('aria-disabled', 'true'); }
      });
    });

    root.addEventListener('click', function (e) {
      var btn = e.target instanceof Element ? e.target.closest('[data-sp-shape]') : null;
      if (!btn || btn.classList.contains('is-on') || btn.classList.contains('is-off')) return;
      var u = target[btn.dataset.spShape];
      if (u) go(u, root);
    });
  }

  function scan() {
    document.querySelectorAll('[data-sp]:not([data-sp-ready])').forEach(function (r) { r.setAttribute('data-sp-ready', ''); init(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
